const kuperShifts = {
    colsOrder: ['number', 'executor', 'amount', 'date', 'status'],
    cols: {
        number: { content: '№', width: 7 },
        executor: { content: 'Исполнитель', width: 50, isAdminMain: true },
        amount: { content: 'Сумма', width: 13 },
        date: { content: 'Период', width: 14 },
        status: { content: 'Статус', width: 16 },
    },
    adminIndex: 1,
    deletesCols: [],
    url: 'kuperShift',
    emptyInfo: {
        title: 'Смен пока нет',
        description: 'Вы можете импортировать смены на общей странице',
    },
} as const;

export default kuperShifts;
